import { render, staticRenderFns } from "./PerformanceForm.vue?vue&type=template&id=ae7b35bc"
import script from "./PerformanceForm.vue?vue&type=script&lang=js"
export * from "./PerformanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports